/** Where points of the scene land on the screen, for the tags and gauges that float over the planet. */
import * as THREE from 'three';

export interface ScreenPoint {
  /** CSS pixels from the top left. */
  x: number;
  y: number;
  /** Behind the camera: the point shows mirrored. */
  behind: boolean;
  /** On the side of the planet that faces the camera, give or take the limb asked for. */
  facing: boolean;
}

export interface Projector {
  readonly width: number;
  readonly height: number;
  setSize(width: number, height: number): void;
  /**
   * Project `point` (scene space) into `out`. It faces while the camera sees it from above its own
   * horizon down to `limb` (0: the horizon; below: a little over the planet's edge).
   */
  project(point: THREE.Vector3, limb: number, out: ScreenPoint): ScreenPoint;
}

export const screenPoint = (): ScreenPoint => ({ x: 0, y: 0, behind: false, facing: false });

export function createProjector(camera: THREE.Camera): Projector {
  const ndc = new THREE.Vector3();
  const toCamera = new THREE.Vector3();
  let width = 1;
  let height = 1;
  return {
    get width() {
      return width;
    },
    get height() {
      return height;
    },
    setSize(w, h) {
      width = w;
      height = h;
    },
    project(point, limb, out) {
      toCamera.copy(camera.position).sub(point).normalize();
      out.facing = ndc.copy(point).normalize().dot(toCamera) > limb;
      ndc.copy(point).project(camera);
      out.behind = ndc.z > 1;
      out.x = ((ndc.x + 1) / 2) * width;
      out.y = ((1 - ndc.y) / 2) * height;
      return out;
    },
  };
}
